import React, { Component } from "react";
import { Modal, Form, FormGroup, ControlLabel, FormControl, Button } from "react-bootstrap";
import Functions from "../../../src/util/functions";

export default class UpdateDetailsModal extends Component {
    render() {
        const user = this.props.currentUser;
        let formBody;

        switch (this.props.modalType) {
        case 1:
            formBody = (
                <div>
                    <FormControl type="hidden" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                    <FormGroup controlId="formHorizontalEmail">
                        <FormControl type="email" placeholder="New e-mail address" name="user[email]" required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalPassword">
                        <FormControl type="password" placeholder="Confirm  password" name="user[password]" required />
                    </FormGroup>

                    <FormGroup>
                        <Button type="submit" onClick={this.props.handleSubmit}>Update e-mail address</Button>
                    </FormGroup>
                </div>
            );
            break;
        case 2:
            formBody = (
                <div>
                    <FormControl type="hidden" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                    <FormGroup controlId="formHorizontalFirstName">
                        <FormControl type="text" placeholder="First name" name="user[first_name]" defaultValue={user.first_name} required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalLastName">
                        <FormControl type="text" placeholder="Last name" name="user[last_name]" defaultValue={user.last_name} required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalPassword">
                        <FormControl type="password" placeholder="Confirm password" name="user[password]" required />
                    </FormGroup>

                    <FormGroup>
                        <Button type="submit" onClick={this.props.handleSubmit}>Update name</Button>
                    </FormGroup>
                </div>
            );
            break;
        case 3:
            formBody = (
                <div>
                    <FormControl type="hidden" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                    <FormGroup controlId="formHorizontalPassword">
                        <FormControl type="password" placeholder="Old password" name="user[password]" required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalNewPassword">
                        <FormControl type="password" placeholder="New password" name="user[new_password]" required />
                    </FormGroup>

                    <FormGroup controlId="formHorizontalConfirmedPassword">
                        <FormControl type="password" placeholder="Confirm new password" name="user[confirmed_password]" required />
                    </FormGroup>

                    <FormGroup>
                        <Button type="submit" onClick={this.props.handleSubmit}>Update password</Button>
                    </FormGroup>
                </div>
            );
            break;
        }

        let messageClass,
            message;
        if (this.props.successMessage) {
            messageClass = " success";
            message = this.props.successMessage;
        } else if (this.props.errorMessage) {
            messageClass = " error";
            message = this.props.errorMessage;
        }

        return (
            <Modal className="update-details-modal" show={this.props.show} onHide={this.props.close}>
                <Modal.Header>
                    <Modal.Title>Enter details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={`message${messageClass}`}>{message}</div>
                    <Form action="/users/update-details.json" method="POST">
                        {formBody}
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/UpdateDetailsModal.jsx.erb